import React, { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import { useNavigate } from "react-router-dom";
import Table from "../Table/Table";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import { toast } from "react-toastify";

export default function News() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [imglink, setimglink] = useState("");
   const [content, setcontent] = useState("");
  const [upiid, setupiid] = useState("");
  const [Type, setType] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/Addnew",
        {
          loginid: userId,
          var:1
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //console.log("ewalletDetails", responceRight?.data?.data[0]);
      //   console.log("response", responceRight);
      responceRight = responceRight?.data?.data1[0];
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          content:item?.content,
          edate: `${item?.edate}`,
        });
      });
      setleftreferralApi(arrayLeft);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const OnhandleSubmit_API = async () => {
    try {
      if(content=='')
      {
        toast.error("Insert content")
        return;
      }
     
      let responceRight = await API?.post(
        `Addnew`,
        {
          loginid: userId,
          id: "",
          content: content,
          img: "",
          ipaddress:"",
          var:4
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("submit", responceRight?.data?.data);
      //console.log("response", responceRight?.data?.data[0][0]);
      //responceRight = responceRight?.data?.data[0][0];
      if (responceRight?.data?.data == "Success") {
        toast.success("Updated Successfully !!");
        referral_API();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(responceRight?.data?.data);
      }
    } catch (e) {
      console.log("error directdeposite APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "" }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;

  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "Content", accessor: "content" },
      { Header: "Date ", accessor: "edate" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div className="content-page">
        <div className="content">
          <div className="container">
            {/* <!-- Inline Form --> */}
            <div className="row">
              <div className="col-md-12">
                <div className="panel panel-primary">
                  <div className="panel-heading">
                    <h4 className="panel-title"> News</h4>
                  </div>
                  <div
                    className="panel-body table-rep-plugin"
                    style={{ padding: "8px", overflowY: "scroll" }}>
                    <div className="col-md-12">
                      <>
                        {" "}
                        <div className="row mb-5">
                          <form>
                            <div className="col-sm-3">
                              <textarea
                                className="form-control in-ip-1"
                                id="content"
                                onChange={(e) => setcontent(e.target.value)}
                                name="content"
                                placeholder="Enter News Content"
                                type="text"
                                value={content}
                              />
                            </div>
                      
                            <div className="col-sm-1">
                              <input
                                type="button"
                                id="btnsearch"
                                onClick={() => OnhandleSubmit_API()}
                                className="btn btn-sm btn-primary"
                                value="Update"
                              />
                            </div>
                          </form>
                        </div>
                      </>
                      <div className="row panel panel-primary">
                        <div className="panel-heading">
                          <h4 className="panel-title"> News</h4>
                        </div>
                        <div
                          className="table-responsive"
                          data-pattern="priority-columns"
                          style={{ maxHeight: "500px", overflow: "scroll" }}>
                          <Table
                            data={currentPostleft}
                            columns={my_team.cols}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
